export const BITACORA_GET_DATA = 'BITACORA_GET_DATA'
export const BITACORA_GET_DATA_SUCCESS = 'BITACORA_GET_DATA_SUCCESS'
export const BITACORA_GET_DATA_FAILURE = 'BITACORA_GET_DATA_FAILURE'